import type { IData } from "~/interfaces";
import { formatUserId } from "~/utils/crm";

const data: IData = getThemeData();

export default defineNuxtPlugin(() => {
    return {
        provide: {
            crmLoadClientData: async <T>(controlField: string): Promise<T> => {
                
                const userId = getStateValue("userId");
                const codeCampaign = getStateValue("codeCampaign");
                const trackCode = getStateValue("trackCode");

                return new Promise((resolve, reject) => {

                    if (!userId || !codeCampaign) reject(false);

                    $fetch(
                        `${data.endpoints.crm as string}/track/dem-info-secure`,
                        {
                            method: "POST",
                            body: {
                                userId: formatUserId(userId),
                                codeCampaign,
                                trackCode
                            },
                        }
                    ).then((response) => {
                        const clientData = response as T 
                        if(clientData && Object.hasOwn(clientData, controlField) )
                            resolve(clientData)
                        else
                            reject('Missing data from CRM payload')
                    })
                    .catch(function() {
                        reject(false)
                    })
                })

            }
        }
    }
})

